/* Glow & Go: AJAX Add-to-Cart for Best Sellers (and any .gg-add-form on the page) */
(function () {
  if (window.__ggAjaxCartInit) return;
  window.__ggAjaxCartInit = true;

  const ADDED_LABEL = "Added";
  const ADDING_LABEL = "Adding…";
  const FAILED_LABEL = "Try again";
  const REVERT_DELAY = 1600;

  function updateCartBubble(count) {
    // Theme's cart-icon component refs
    document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function (el) {
      el.textContent = count < 100 ? String(count) : "";
      if (count > 0) el.classList.remove("hidden");
      else el.classList.add("hidden");
    });

    document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(function (el) {
      if (count > 0) el.classList.remove("visually-hidden");
      else el.classList.add("visually-hidden");
    });

    // Fallback selectors for other cart count indicators
    const fallbackSelectors = [
      "[data-cart-count]",
      ".cart-count",
      ".cart-bubble__count",
      ".cart-icon__count",
      "cart-icon-component [part='count']"
    ];
    document.querySelectorAll(fallbackSelectors.join(",")).forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute("hidden");
        el.removeAttribute("aria-hidden");
      }
    });
  }

  function dispatchCartUpdate(cart, sourceId) {
    // Mirror the theme's CartUpdateEvent shape (assets/events.js)
    const evt = new Event("cart:update", { bubbles: true });
    evt.detail = {
      resource: cart,
      sourceId: sourceId || "gg-ajax-add",
      data: {
        source: "gg-ajax-add",
        itemCount: cart ? cart.item_count : undefined
      }
    };
    document.dispatchEvent(evt);
  }

  function currentBubbleCount() {
    const el = document.querySelector('[ref="cartBubbleCount"]');
    if (!el) return 0;
    const parsed = parseInt(el.textContent || "0", 10);
    return isNaN(parsed) ? 0 : parsed;
  }

  function fetchCartAndSync() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBubble(cart.item_count);
        dispatchCartUpdate(cart);
        return cart;
      })
      .catch(function () { /* swallow */ });
  }

  function handleSubmit(event) {
    const form = event.target.closest && event.target.closest(".gg-add-form");
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    // Quantity submitted (defaults to 1 if no quantity input)
    const qtyInput = form.querySelector('input[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    // 1. Optimistic UI: bump cart bubble immediately
    const optimisticCount = currentBubbleCount() + qty;
    updateCartBubble(optimisticCount);

    const originalLabel = button.textContent.trim();
    button.disabled = true;
    button.dataset.ggOriginalLabel = originalLabel;
    button.textContent = ADDING_LABEL;

    const body = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: body,
      credentials: "same-origin"
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        button.textContent = ADDED_LABEL;
        button.classList.add("gg-add--success");
        // 2. Authoritative refresh: replace optimistic count with real one
        return fetchCartAndSync();
      })
      .then(function () {
        setTimeout(function () {
          button.textContent = originalLabel;
          button.classList.remove("gg-add--success");
          button.disabled = false;
        }, REVERT_DELAY);
      })
      .catch(function (err) {
        console.error("Glow & Go AJAX add-to-cart failed:", err);
        // Revert optimistic count
        fetchCartAndSync();
        button.textContent = FAILED_LABEL;
        button.classList.add("gg-add--error");
        setTimeout(function () {
          button.textContent = originalLabel;
          button.classList.remove("gg-add--error");
          button.disabled = false;
        }, REVERT_DELAY + 600);
      });
  }

  document.addEventListener("submit", handleSubmit, true);
})();
